/* eslint-disable react/no-danger, react/forbid-prop-types */
/* phpcs:disable WordPressVIPMinimum.JS.DangerouslySetInnerHTML.dangerouslySetInnerHTML */

import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import React from 'react';

const SafeHTML = ({
  html,
  tag: Tag,
  ...rest
}) => (
  <Tag
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(html),
    }}
    {...rest}
  />
);

SafeHTML.defaultProps = {
  rest: {},
};

SafeHTML.propTypes = {
  html: PropTypes.string.isRequired,
  rest: PropTypes.object,
  tag: PropTypes.string.isRequired,
};

export default SafeHTML;
